import { render, staticRenderFns } from "./ImageLink.vue?vue&type=template&id=40ed6c9c&scoped=true&"
import script from "./ImageLink.vue?vue&type=script&lang=ts&"
export * from "./ImageLink.vue?vue&type=script&lang=ts&"
import style0 from "./ImageLink.vue?vue&type=style&index=0&id=40ed6c9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ed6c9c",
  null
  
)

export default component.exports